<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="
      t('shipmentFinancials.paramEstimate', {
        param: t('shipmentFinancials.cost'),
      })
    "
    class="cost-estimate-filter"
    optional
  >
    <MoneyFilter
      :id="inputId"
      v-model="costEstimateFilter"
      :placeholder="
        t('shipmentFinancials.paramEstimate', {
          param: t('shipmentFinancials.cost'),
        })
      "
      append-to="body"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { MoneySearchFilter, ShipmentSearchCriteria } from '@/model';

import MoneyFilter from '@/components/search/MoneyFilter.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const internalValue = defineModel({
  type: Object as PropType<ShipmentSearchCriteria>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);

const { t } = useI18n();

const costEstimateFilter = computed({
  get() {
    return new MoneySearchFilter({
      min: internalValue.value.costEstimate?.min,
      max: internalValue.value.costEstimate?.max,
      currency: internalValue.value.costEstimate?.currency,
    });
  },
  set(newVal: MoneySearchFilter) {
    internalValue.value.costEstimate = new MoneySearchFilter(newVal);
  },
});
</script>
